export default "__VITE_PUBLIC_ASSET__791c5260__"